<mat-card class="files-card">
  <mat-card-title class="grid-item-title">
    {{ 'ppwrDocuments.title' | transloco }}
  </mat-card-title>

  <mat-card-content class="table-container-wide">
    <input type="file" accept=".pdf" #replaceInput style="display: none" (change)="onReplaceFileSelected($event)" />
    <div *ngIf="documents && documents.length > 0">
      <div class="pdfs-container">
        <div *ngFor="let ppwrdoc of documents; let i = index" class="file-container">
          <mat-form-field #formFieldInput [ngStyle]="{ 'width.px': nameFieldWidth[i] }" appearance="outline" class="name-input-container">
            <input
              matInput
              class="name-input"
              [(ngModel)]="ppwrdoc.name"
              (paste)="resizeInput(i)"
              (cut)="resizeInput(i)"
              (input)="resizeInput(i)"
              (change)="onNameEditClicked(i)"
              (click)="setCurrentNameBeforeChange(documents, i)"
              [disabled]="!canEditForm" />
            <mat-icon matPrefix>edit</mat-icon>
            <mat-icon matSuffix *ngIf="ppwrdoc.name.length === 0" class="error-name-icon">error</mat-icon>
          </mat-form-field>

          <span class="spacer"></span>

          <ng-container *ngIf="ppwrdoc.source === PpwrDocumentSource.UserUploaded; else readonlyTypeBadge">
            <button type="button" class="type-dropdown" [ngClass]="getDocumentTypeCssClass(ppwrdoc.documentType)" [matMenuTriggerFor]="documentTypeMenu" [disabled]="!canEditForm">
              {{ getDocumentTypeLabel(ppwrdoc.documentType) }}

              <mat-icon>expand_more</mat-icon>
            </button>

            <mat-menu #documentTypeMenu="matMenu">
              <button *ngFor="let option of documentTypeOptions" mat-menu-item (click)="onDocumentTypeChange(ppwrdoc, option.value)">
                {{ getDocumentTypeLabel(option.value) }}
              </button>
            </mat-menu>
          </ng-container>

          <ng-template #readonlyTypeBadge>
            <div class="doc-type-badge" [ngClass]="getDocumentTypeCssClass(ppwrdoc.documentType)">
              {{ getDocumentTypeLabel(ppwrdoc.documentType) }}
            </div>
          </ng-template>

          <div class="doc-source-badge" [class.paco]="ppwrdoc.source === PpwrDocumentSource.PacoGenerated" [class.user]="ppwrdoc.source === PpwrDocumentSource.UserUploaded">
            {{ ppwrdoc.source === PpwrDocumentSource.PacoGenerated ? ('ppwrDocuments.sourcePaco' | transloco) : ('ppwrDocuments.sourceUser' | transloco) }}
          </div>

          <button mat-icon-button color="primary" type="button" (click)="onViewDocumentClick(ppwrdoc)" matTooltip="{{ 'pdf.tooltips.viewPdf' | transloco }}">
            <mat-icon>preview</mat-icon>
          </button>

          <button
            *ngIf="canUpdateDocument(ppwrdoc)"
            mat-icon-button
            color="primary"
            type="button"
            (click)="onUpdateClick(ppwrdoc, replaceInput)"
            matTooltip="{{ 'ppwrDocuments.updateTooltip' | transloco }}">
            <mat-icon>update</mat-icon>
          </button>

          <button
            *ngIf="canRevertDocument(ppwrdoc)"
            mat-icon-button
            color="primary"
            type="button"
            (click)="onRevertClick(ppwrdoc)"
            matTooltip="{{ 'ppwrDocuments.revertTooltip' | transloco }}">
            <mat-icon>undo</mat-icon>
          </button>

          <button
            mat-icon-button
            color="primary"
            type="button"
            [disabled]="!canEditForm"
            (click)="onDeleteClick(ppwrdoc)"
            matTooltip="{{ 'pdf.tooltips.deletePdf' | transloco }}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="canEditForm">
      <input type="file" accept=".pdf" #docInput onclick="value=null" style="display: none" (change)="onFileSelected($event, PpwrDocumentType.DoC)" />
      <input type="file" accept=".pdf" #tdInput onclick="value=null" style="display: none" (change)="onFileSelected($event, PpwrDocumentType.TD)" />

      <button mat-raised-button color="primary" class="custom-button-top" type="button" (click)="docInput.click()">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'ppwrDocuments.uploadDoc' | transloco }}
      </button>

      <button mat-raised-button color="primary" class="custom-button-top" type="button" (click)="tdInput.click()">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'ppwrDocuments.uploadTd' | transloco }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
